<template>
  <div v-if="drawer">
    <v-navigation-drawer app class="navigation_drawer" :mini-variant="miniState" absolute :width="180"
      v-if="isLoggedIn" style="height: 100vh;position: fixed;z-index: 999999;margin-top: 64px;">

      <div :class="{ 'is-mini': miniState }" style="">
        <v-list class="pa-0">
          <v-list-item-group v-model="selectedItem">
            <v-list-item v-for="(item, index) in items" :key="index" @click="selectItem(item)" :value="item"
              :to="item.to">
                <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                </template>
                <span>{{ item.title }}</span>
              </v-tooltip>
              <v-list-item-content v-show="!mini">
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer :width="200" app class="group_list_drawer" v-if="isLoggedIn && groupListDrawer"
      :clipped="$vuetify.breakpoint.lgAndUp" absolute>
      <GroupList :mini="miniState" :view-type="currentViewType" />
    </v-navigation-drawer>

    <v-navigation-drawer :width="180" app class="sub_menu_drawer" v-if="isLoggedIn && subMenuDrawer"
      :clipped="$vuetify.breakpoint.lgAndUp" absolute>
      <SubMenu :selected-item="selectedItem" class="submenu" @mini="handleMiniModeChange" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import GroupList from './TheGroupList.vue';
import SubMenu from './TheSubMenu.vue';

export default {
  name: 'TheDrawer',
  components: {
    GroupList,
    SubMenu,
  },
  props: {
    drawer: Boolean,
    //items: Array,
  },
  data() {
    return {
      //drawer: true,
      miniState: false,
      selectedItem: null,
      mini: false,
      subMenuDrawer: false,
      groupListDrawer: false,
      localDrawer: this.drawer,
      flag: false,
    };
  },
  methods: {
    handleMiniModeChange(miniStatus) {
      this.$set(this, 'mini', miniStatus);
    },
    selectItem(item) {
      if (this.selectedItem === item) {
        this.flag = !this.flag;
        if(this.flag){
          
        }
        else {

        }
      }
      else {
        this.flag = false;
        this.$set(this, 'selectedItem', item);

        if (item.to === '/playlist' || item.to === '/asset') {
          this.groupListDrawer = true;
          this.subMenuDrawer = false;
        }
        else if (item.children && item.children.length > 0) {
          this.groupListDrawer = false;
          this.subMenuDrawer = true;
          this.navigateToFirstChild(item);
        }
        else {
          this.groupListDrawer = false;
          this.subMenuDrawer = false;
          this.navigateToItem(item);
          if (item.to && this.$route.path !== item.to) {
            this.$router.push(item.to).catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                throw err;
              }
            });
          }
        }
      }
    },
    navigateToFirstChild(item) {
      let route = this.findFirstRoute(item);
      if (route) {
        this.$router.push(route).then(() => {
          this.subMenuDrawer = true;
          this.groupListDrawer = false;
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation Error:', err);
          }
        });
      } else {
        this.subMenuDrawer = false;
        this.groupListDrawer = false;
        this.miniState = false;
      }
    },
    findFirstRoute(item) {
      if (item.to) {
        return item.to;
      }
      if (item.children && item.children.length > 0) {
        return this.findFirstRoute(item.children[0]);
      }
      return null;
    },
    navigateToItem(item) {
      if (item.to) {
        this.$router.push(item.to).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation Error:', err);
          }
        });
      } else {
        this.subMenuDrawer = false;
        this.groupListDrawer = false;
        this.miniState = false;
      }
    },
    updateDrawerState() {
      if (!this.items || this.items.length === 0) {
        return;
      }
      const path = this.$route.path;
      //console.log('update', path);
      const specialRoutes = ['/playlist', '/asset'];

      const matchedItem = this.items.find(item => item.to === path) ||
        this.items.find(item =>
          item.children?.some(child =>
            child.to === path || child.children?.some(grandchild => grandchild.to === path)
          )
        );
      if (matchedItem) {
        this.miniState = specialRoutes.includes(path) || (Array.isArray(matchedItem.children) && matchedItem.children.length > 0);
        this.selectItem(matchedItem);
      }
    },
  },
  mounted() {
    //this.updateDrawerState();
  },
  computed: {
    items() {
      return this.$store.state.naviList.items;
    },
    isLoggedIn() {
      return this.$store.getters['user/isLoggedIn'];
    },
    drawerIcon() {
      return this.drawer ? 'mdi-chevron-left' : 'mdi-menu';
    },
    currentViewType() {
      if (!this.selectedItem) return '';
      //console.log('currentViewType', this.selectedItem);
      return this.selectedItem.to === '/playlist' ? 'playlist' : (this.selectedItem.to === '/asset' ? 'asset' : '');
    },
    shouldDisplayGroupList() {
      console.log('shouldDisplayGroupList', this.currentViewType);
      const display = this.currentViewType == 'playlist' || this.currentViewType == 'asset';
      //console.log('display', display);
      return display;
    },
  },
  watch: {
    '$route'(to, from) {
      this.updateDrawerState();
      // if (this.items && this.items.length > 0) {
      //   this.updateDrawerState();
      // }
    },
    items: {
      deep: true,
      handler(newVal, oldVal) {
        //this.updateDrawerState();
        if (newVal && newVal.length > 0) {
          this.updateDrawerState();
        }
      },
    },
    drawer(newVal) {
      this.localDrawer = newVal;
    },
    localDrawer(newVal) {
      this.$emit('update:drawer', newVal);
    },
  },
}
</script>

<style lang="scss" scoped>
.group_list_drawer {
  margin-left: 60px;
}

.sub_menu_drawer {
  margin-left: 60px;
}


.navigation_drawer {
  height: auto;
}

.mini-items .v-list-item-icon {
  min-width: 56px;
}

.v-list-item {
  align-items: center !important;
}

.mini-items .v-list-item {
  justify-content: center;
}

.flex-container {
  display: flex;
  width: 100%;
}

.mini-items {
  width: 50px;
  transition: width 0.3s ease;
}

.selected-item {
  background-color: #e0e0e0;
}
</style>